<template>
  <div class="content">
    <!-- <b-row class="mb-3">
      <b-col>
        <img src="@/assets/images/backgrounds/account.jpg" alt="packages" class="img-fluid" />
      </b-col>
    </b-row> -->
    <b-row>
      <b-col md="6">
        <b-card no-body>
          <b-card-header header-bg-variant="primary"><h5 class="mb-0 text-white">Date companie</h5></b-card-header>
          <b-list-group flush class="list-dense">
            <b-list-group-item>
              <span class="user-details">Cod agentie:</span><span > {{ userData.code }}</span>
            </b-list-group-item>
            <b-list-group-item>
              <span class="user-details">Denumire agentie:</span><span> {{ userData.name }}</span>
            </b-list-group-item>
            <b-list-group-item>
              <span class="user-details">Nivel comision:</span><span> {{ userData.groupName }}</span>
            </b-list-group-item>
            <b-list-group-item>
              <span class="user-details">Denumire companie:</span><span >{{ userData.companyName }}</span>
            </b-list-group-item>
            <b-list-group-item>
              <span class="user-details">Cod fiscal:</span><span> {{ userData.vatNo }}</span>
            </b-list-group-item>
            <b-list-group-item>
              <span class="user-details">Nr. Reg Comertului:</span><span > {{ userData.companyNo }}</span>
            </b-list-group-item>
            <b-list-group-item>
              <span class="user-details">Adresa:</span><span> {{ userData.address }}</span>
            </b-list-group-item>
            <b-list-group-item>
              <span class="user-details">Cont:</span><span> {{ userData.bankAccount }}</span>
            </b-list-group-item>
            <b-list-group-item>
              <span class="user-details">Banca:</span><span> {{ userData.bankName }}</span>
            </b-list-group-item>
            <b-list-group-item>
              <span class="user-details">Email:</span><span><a :href="'mailto:' + userData.email">{{ userData.email }}</a></span>
            </b-list-group-item>
            <b-list-group-item>
              <span class="user-details">Telefon:</span><span> {{ userData.tel }}</span>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>
      <b-col md="6">
        <b-card no-body>
          <b-card-header header-bg-variant="primary"><h5 class="mb-0 text-white">Date utilizator</h5></b-card-header>
          <b-list-group flush class="list-dense">
            <b-list-group-item>
              <span class="user-name">Nume Login:</span><span> {{ userData.username }}</span>
            </b-list-group-item>
            <b-list-group-item>
              <span class="user-name">Nume Complet:</span><span> {{ userData.title }} {{ userData.fname }} {{ userData.lname }}</span>
            </b-list-group-item>
            <b-list-group-item>
              <span class="user-name">Email:</span><span> <a :href="'mailto:' + userData.email"> {{ userData.email }}</a></span>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import authMixin from './shared/mixins/auth'

export default {
  mixins: [authMixin]
}
</script>
